import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './project-time.types';

export const projectTimeSelectors = {
  ...generateResourceSelectors<types.IProjectTasksTime>((state) => state.resource.projectTime),
};
